import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MessageService } from 'primeng/api';
import { bmxurl } from 'src/globals';
import { cVenuesettings } from 'src/types/venuesettings';
import { cVenuesetting } from 'src/types/venuesetting';
import { venuesettings_returndata } from 'src/types/venuesettings_returndata';
import { BusyService } from '../_services/busy.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-mailchimp',
  templateUrl: './mailchimp.component.html',
  styleUrls: ['./mailchimp.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class MailChimpComponent implements OnInit {

  VenueID: string = localStorage.getItem("SmartVenueID")!;
  AccessAllowed: boolean = false;
  CompletedLoading: boolean = false;
  httpResponse: any;
  mailchimpEnabled: boolean = false;
  apiKey: string = "";
  settingsSaving: boolean = false;
  venuesettings: cVenuesettings;

  // All venue settings (required to avoid wiping other settings on save)
  BNemail: string = "";
  BookingNotification: boolean = false;
  vsDiagnostics: boolean = true;
  vsPBWStyle: string = "DATEFIRST";
  vsMinimalDetails: boolean = true;
  vsImageURL: string = "";
  vsImageReturnURL: string = "";
  vsGTMCode: string = "";
  vsConfirmations: string = "Email";
  defInterval: number = 0;
  imageWidth: number = 0;
  imageHeight: number = 0;
  idleTimeout: number = 0;
  AllowTimeOut: boolean = false;
  RyftSubAccountID: string = "";
  GoogleTagManagerID: string = "";
  returnPage: string = "";
  WebhookURL: string = "";
  NoAvailabilityMessage: string = "There are no times available that match your criteria";
  UseCounters: boolean = false;
  SummaryItinerary: boolean = false;
  IgnoreDateRestrictions: boolean = false;
  defaultColour: string = "#5974af";
  chosenTimezone: any;
  chosenCurrency: any;
  chosenCulture: any;
  BookingsCannotBeMadeWithinXMinutes: number = 0;
  BookingsCannotBeMadeAfterXMinutes: number = 0;
  CannotMakeBookingsToday: boolean = false;
  betaemailing: boolean = false;
  betatask: boolean = false;
  betamembership: boolean = false;
  PaymentAmountSelection: any = "DEPOSIT";
  ChosenHomePage: any = {value: "home", name: "Bookings Created Today"};
  waiverminage: number = 18;
  selectedPaymentLinkEmailTemplate: any;
  selectedVoucherEmailTemplate: any;
  selectedCancelledBookingEmailTemplate: any;
  WaiversActive: boolean = false;
  MinWaiverAge: any = {name: "18 Years", value: 18};
  WaiverMinAgeParticipate: any = {name: "0 Years", value: 0};
  SimRacingEnabled: boolean = false;
  SimRacingAPIKey: string = "";
  SimRacingVenueID: string = "";
  BrevoEnabled: boolean = false;
  BrevoAPIKey: string = "";
  MailChimpEnabled: boolean = false;
  MailChimpAPIKey: string = "";

  mailchimpStateOptions = [
    { label: 'No', value: false },
    { label: 'Yes', value: true }
  ];

  constructor(
    private http: HttpClient,
    private messageService: MessageService,
    private busyService: BusyService,
    private router: Router
  ) {
    this.getVenueSettings();
  }

  ngOnInit(): void {
    this.AccessAllowed = true;
    this.CompletedLoading = true;
  }

  updateSettingsData(showmessage: boolean = true, callback?: () => void) {
    let vsDiagnosticsContainer = new cVenuesetting;
    let vsPBWStyleContainer = new cVenuesetting;
    let vsMinimalDetailsContainer = new cVenuesetting;
    let vsImageURLContainer = new cVenuesetting;
    let vsImageReturnURLContainer = new cVenuesetting;
    let vsDefInterval = new cVenuesetting;
    let vsIdleTimeout = new cVenuesetting;
    let vsConfirmation = new cVenuesetting;
    let vsAllowTimeOut = new cVenuesetting;
    let vsUseCounters = new cVenuesetting;
    let vsSummaryItinerary = new cVenuesetting;
    let vsIgnoreDateRestrictions = new cVenuesetting;
    let vsRyftSubAccountID = new cVenuesetting;
    let vsGoogleTagManagerID = new cVenuesetting;
    let vsReturnPage = new cVenuesetting;
    let vsWebHookURL = new cVenuesetting;
    let vsNoAvailabilityMessage = new cVenuesetting;
    let vsBookingNotificationEmail = new cVenuesetting;
    let vsBookingNotification = new cVenuesetting;
    let vsSimRacingEnabled = new cVenuesetting;
    let vsSimRacingAPiKey = new cVenuesetting;
    let vsSimRacingVenueID = new cVenuesetting;
    let vsBrevoEnabled = new cVenuesetting;
    let vsBrevoAPIKey = new cVenuesetting;
    let vsMailChimpEnabled = new cVenuesetting;
    let vsMailChimpAPIKey = new cVenuesetting;

    vsBookingNotificationEmail.name = "BookingNotificationEmail";
    vsBookingNotificationEmail.value = this.BNemail;
    vsBookingNotification.name = "BookingNotification";
    vsBookingNotification.value = String(this.BookingNotification);
    vsDiagnosticsContainer.name = "AvailabilityDiagnostics";
    vsDiagnosticsContainer.value = String(this.vsDiagnostics);
    vsPBWStyleContainer.name = "PBWStyle";
    vsPBWStyleContainer.value = String(this.vsPBWStyle);
    vsConfirmation.name = "EMailSMSConfirmation";
    vsConfirmation.value = String(this.vsConfirmations);
    vsDefInterval.name = "DefaultInterval";
    vsDefInterval.value = this.defInterval.toString();
    vsIdleTimeout.name = "idleTimeout";
    vsIdleTimeout.value = this.idleTimeout.toString();
    vsRyftSubAccountID.name = "RyftSubAccountID";
    vsRyftSubAccountID.value = String(this.RyftSubAccountID);
    vsGoogleTagManagerID.name = "GoogleTagManagerID";
    vsGoogleTagManagerID.value = String(this.GoogleTagManagerID);
    vsReturnPage.name = "returnPage";
    vsReturnPage.value = String(this.returnPage);
    vsWebHookURL.name = "WebHookURL";
    vsWebHookURL.value = String(this.WebhookURL);
    vsNoAvailabilityMessage.name = "NoAvailabilityMessage";
    vsNoAvailabilityMessage.value = String(this.NoAvailabilityMessage);
    vsAllowTimeOut.name = "AllowTimeOut";
    vsAllowTimeOut.value = String(this.AllowTimeOut);
    vsUseCounters.name = "UseCounters";
    vsUseCounters.value = String(this.UseCounters);
    vsSummaryItinerary.name = "SummaryItinerary";
    vsSummaryItinerary.value = String(this.SummaryItinerary);
    vsIgnoreDateRestrictions.name = "IgnoreDateRestrictions";
    vsIgnoreDateRestrictions.value = String(this.IgnoreDateRestrictions);
    vsSimRacingEnabled.name = "simracing_enabled";
    vsSimRacingEnabled.value = String(this.SimRacingEnabled);
    vsSimRacingAPiKey.name = "simracing_apikey";
    vsSimRacingAPiKey.value = String(this.SimRacingAPIKey);
    vsSimRacingVenueID.name = "simracing_venueid";
    vsSimRacingVenueID.value = String(this.SimRacingVenueID);
    vsBrevoEnabled.name = "brevo_enabled";
    vsBrevoEnabled.value = String(this.BrevoEnabled);
    vsBrevoAPIKey.name = "brevo_apikey";
    vsBrevoAPIKey.value = String(this.BrevoAPIKey);
    vsMailChimpEnabled.name = "mailchimp_enabled";
    vsMailChimpEnabled.value = String(this.MailChimpEnabled);
    vsMailChimpAPIKey.name = "mailchimp_apikey";
    vsMailChimpAPIKey.value = String(this.MailChimpAPIKey);

    vsMinimalDetailsContainer.name = "MinimalDetails";
    vsMinimalDetailsContainer.value = String(this.vsMinimalDetails);
    vsImageURLContainer.name = "PublicImgURL";
    vsImageURLContainer.value = String(this.vsImageURL);
    vsImageReturnURLContainer.name = "ImageReturnURL";
    vsImageReturnURLContainer.value = String(this.vsImageReturnURL);

    let vsGTMCodeContainer = new cVenuesetting;
    vsGTMCodeContainer.name = "GTMCode";
    vsGTMCodeContainer.value = String(this.vsGTMCode);

    let vsImageWidth = new cVenuesetting;
    vsImageWidth.name = "PublicImageWidth";
    vsImageWidth.value = String(this.imageWidth);

    let vsMinWaiverAge = new cVenuesetting;
    vsMinWaiverAge.name = "WaiverMinAge";
    vsMinWaiverAge.value = String(this.MinWaiverAge.value);

    let vsMinWaiverAgeParticipate = new cVenuesetting;
    vsMinWaiverAgeParticipate.name = "MinWaiverAgeParticipate";
    vsMinWaiverAgeParticipate.value = String(this.WaiverMinAgeParticipate.value);

    let vsImageHeight = new cVenuesetting;
    vsImageHeight.name = "PublicImageheight";
    vsImageHeight.value = String(this.imageHeight);

    let vsColour = new cVenuesetting;
    vsColour.name = "DefaultColour";
    vsColour.value = String(this.defaultColour);

    let vsTimezone = new cVenuesetting;
    vsTimezone.name = "TimeZone";
    vsTimezone.value = String(this.chosenTimezone);

    let vsCurrency = new cVenuesetting;
    vsCurrency.name = "Currency";
    vsCurrency.value = String(this.chosenCurrency);

    let vsCulture = new cVenuesetting;
    vsCulture.name = "Culture";
    vsCulture.value = String(this.chosenCulture);

    let vsBookingsCannotBeMadeWithinXMinutes = new cVenuesetting;
    vsBookingsCannotBeMadeWithinXMinutes.name = "BookingsCannotBeMadeWithinXMinutes";
    vsBookingsCannotBeMadeWithinXMinutes.value = String(this.BookingsCannotBeMadeWithinXMinutes);

    let vsBookingsCannotBeMadeAfterXMinutes = new cVenuesetting;
    vsBookingsCannotBeMadeAfterXMinutes.name = "BookingsCannotBeMadeAfterXMinutes";
    vsBookingsCannotBeMadeAfterXMinutes.value = String(this.BookingsCannotBeMadeAfterXMinutes);

    let vsCannotMakeBookingsToday = new cVenuesetting;
    vsCannotMakeBookingsToday.name = "CannotMakeBookingsToday";
    vsCannotMakeBookingsToday.value = String(this.CannotMakeBookingsToday);

    let vsBetaEmailing = new cVenuesetting;
    vsBetaEmailing.name = "BetaEmailing";
    vsBetaEmailing.value = String(this.betaemailing);

    let vsBetaTask = new cVenuesetting;
    vsBetaTask.name = "BetaTask";
    vsBetaTask.value = String(this.betatask);

    let vsBetamembership = new cVenuesetting;
    vsBetamembership.name = "Betamembership";
    vsBetamembership.value = String(this.betamembership);

    let vsPaymentAmountSelection = new cVenuesetting;
    vsPaymentAmountSelection.name = "PaymentAmountSelection";
    vsPaymentAmountSelection.value = String(this.PaymentAmountSelection);

    let vsChosenHomePage = new cVenuesetting;
    if (this.ChosenHomePage != null) {
      vsChosenHomePage.name = "ChosenHomePage";
      vsChosenHomePage.value = String(this.ChosenHomePage.value);
    }

    let vsWaiverMinAge = new cVenuesetting;
    vsWaiverMinAge.name = "waiverminage";
    vsWaiverMinAge.value = String(this.waiverminage);

    let vsSelectedPaymentLinkEmailTemplate = new cVenuesetting;
    if (this.selectedPaymentLinkEmailTemplate != null) {
      vsSelectedPaymentLinkEmailTemplate.name = "PaymentLinkEmailTemplate";
      vsSelectedPaymentLinkEmailTemplate.value = String(this.selectedPaymentLinkEmailTemplate.emailtemplateid);
    }

    let vsSelectedVoucherEmailTemplate = new cVenuesetting;
    if (this.selectedVoucherEmailTemplate != null) {
      vsSelectedVoucherEmailTemplate.name = "VoucherEmailTemplate";
      vsSelectedVoucherEmailTemplate.value = String(this.selectedVoucherEmailTemplate.emailtemplateid);
    }

    let vsSelectedCancelledBookingEmailTemplate = new cVenuesetting;
    if (this.selectedCancelledBookingEmailTemplate != null) {
      vsSelectedCancelledBookingEmailTemplate.name = "CancelledBookingTemplate";
      vsSelectedCancelledBookingEmailTemplate.value = String(this.selectedCancelledBookingEmailTemplate.emailtemplateid);
    }

    let vsWaiverActive = new cVenuesetting;
    vsWaiverActive.name = "WaiverActive";
    vsWaiverActive.value = String(this.WaiversActive);

    this.venuesettings = {
      id: localStorage.getItem("VenueSettingsID"),
      venueid: this.VenueID,
      venuesettings: [
        vsDiagnosticsContainer,
        vsPBWStyleContainer,
        vsMinimalDetailsContainer,
        vsGTMCodeContainer,
        vsImageURLContainer,
        vsImageReturnURLContainer,
        vsConfirmation,
        vsDefInterval,
        vsImageWidth,
        vsImageHeight,
        vsIdleTimeout,
        vsAllowTimeOut,
        vsUseCounters,
        vsSummaryItinerary,
        vsIgnoreDateRestrictions,
        vsColour,
        vsRyftSubAccountID,
        vsGoogleTagManagerID,
        vsReturnPage,
        vsWebHookURL,
        vsNoAvailabilityMessage,
        vsTimezone,
        vsCurrency,
        vsCulture,
        vsSelectedPaymentLinkEmailTemplate,
        vsChosenHomePage,
        vsWaiverMinAge,
        vsSelectedVoucherEmailTemplate,
        vsSelectedCancelledBookingEmailTemplate,
        vsBookingsCannotBeMadeAfterXMinutes,
        vsBookingsCannotBeMadeWithinXMinutes,
        vsCannotMakeBookingsToday,
        vsBetaEmailing,
        vsBetaTask,
        vsBetamembership,
        vsBookingNotificationEmail,
        vsBookingNotification,
        vsWaiverActive,
        vsMinWaiverAge,
        vsMinWaiverAgeParticipate,
        vsSimRacingEnabled,
        vsSimRacingAPiKey,
        vsSimRacingVenueID,
        vsBrevoEnabled,
        vsBrevoAPIKey,
        vsMailChimpEnabled,
        vsMailChimpAPIKey
      ]
    };

    this.http.put<cVenuesettings>(bmxurl + "/venuesettings", this.venuesettings).subscribe(response => {
      this.httpResponse = response;
      if (this.httpResponse.succeeded) {
        if (showmessage)
          this.messageService.add({severity: 'success', summary: 'Saved', detail: 'Venue Settings successfully updated'});

        this.http.get(bmxurl + "venuesettings/" + this.VenueID).subscribe(response => {
          this.httpResponse = (response as venuesettings_returndata);
          if (this.httpResponse.succeeded) {
            localStorage.setItem("VenueSettingsID", this.httpResponse.data.id);
            this.httpResponse.data.venueSettings.forEach(element => {
              localStorage.removeItem(element.name);
              localStorage.setItem(element.name, element.value);
            });
            if (callback) callback();
          } else {
            this.messageService.add({severity: 'error', summary: 'Unable to get Venue Settings'});
          }
        }, error => {
          this.messageService.add({severity: 'error', summary: 'Unable to get Venue Settings'});
        });
      }
    }, error => {
      this.messageService.add({severity: 'error', summary: 'Venue Settings Not Saved', detail: error.messages});
    });
  }

  getVenueSettings() {
    this.busyService.busy();
    this.http.get(bmxurl + "venuesettings/" + this.VenueID).subscribe(response => {
      this.httpResponse = (response as venuesettings_returndata);
      if (this.httpResponse.succeeded) {
        localStorage.setItem("VenueSettingsID", this.httpResponse.data.id);

        this.httpResponse.data.venueSettings.forEach(element => {
          localStorage.removeItem(element.name);
          localStorage.setItem(element.name, element.value);

          switch (element.name) {
            case "AvailabilityDiagnostics": this.vsDiagnostics = element.value === "true"; break;
            case "PBWStyle": this.vsPBWStyle = element.value; break;
            case "MinimalDetails": this.vsMinimalDetails = element.value === "true"; break;
            case "PublicImgURL": this.vsImageURL = element.value; break;
            case "ImageReturnURL": this.vsImageReturnURL = element.value; break;
            case "GTMCode": this.vsGTMCode = element.value; break;
            case "EMailSMSConfirmation": this.vsConfirmations = element.value; break;
            case "DefaultInterval": this.defInterval = parseInt(element.value) || 5; break;
            case "PublicImageWidth": this.imageWidth = parseInt(element.value) || 0; break;
            case "PublicImageheight": this.imageHeight = parseInt(element.value) || 0; break;
            case "idleTimeout": this.idleTimeout = parseInt(element.value) || 0; break;
            case "AllowTimeOut": this.AllowTimeOut = element.value === "true"; break;
            case "RyftSubAccountID": this.RyftSubAccountID = element.value; break;
            case "GoogleTagManagerID": this.GoogleTagManagerID = element.value; break;
            case "returnPage": this.returnPage = element.value; break;
            case "WebHookURL": this.WebhookURL = element.value; break;
            case "NoAvailabilityMessage": this.NoAvailabilityMessage = element.value; break;
            case "UseCounters": this.UseCounters = element.value === "true"; break;
            case "SummaryItinerary": this.SummaryItinerary = element.value === "true"; break;
            case "IgnoreDateRestrictions": this.IgnoreDateRestrictions = element.value === "true"; break;
            case "DefaultColour": this.defaultColour = element.value; break;
            case "TimeZone": this.chosenTimezone = element.value; break;
            case "Currency": this.chosenCurrency = element.value; break;
            case "Culture": this.chosenCulture = element.value; break;
            case "BookingsCannotBeMadeWithinXMinutes": this.BookingsCannotBeMadeWithinXMinutes = parseInt(element.value) || 0; break;
            case "BookingsCannotBeMadeAfterXMinutes": this.BookingsCannotBeMadeAfterXMinutes = parseInt(element.value) || 0; break;
            case "CannotMakeBookingsToday": this.CannotMakeBookingsToday = element.value === "true"; break;
            case "BetaEmailing": this.betaemailing = element.value === "true"; break;
            case "BetaTask": this.betatask = element.value === "true"; break;
            case "Betamembership": this.betamembership = element.value === "true"; break;
            case "PaymentAmountSelection": this.PaymentAmountSelection = element.value; break;
            case "ChosenHomePage": this.ChosenHomePage = {value: element.value, name: element.value}; break;
            case "waiverminage": this.waiverminage = parseInt(element.value) || 18; break;
            case "PaymentLinkEmailTemplate": this.selectedPaymentLinkEmailTemplate = {emailtemplateid: element.value}; break;
            case "VoucherEmailTemplate": this.selectedVoucherEmailTemplate = {emailtemplateid: element.value}; break;
            case "CancelledBookingTemplate": this.selectedCancelledBookingEmailTemplate = {emailtemplateid: element.value}; break;
            case "WaiverActive": this.WaiversActive = element.value === "true"; break;
            case "WaiverMinAge": this.MinWaiverAge = {name: element.value + " Years", value: parseInt(element.value) || 18}; break;
            case "MinWaiverAgeParticipate": this.WaiverMinAgeParticipate = {name: element.value + " Years", value: parseInt(element.value) || 0}; break;
            case "simracing_enabled": this.SimRacingEnabled = element.value === "true"; break;
            case "simracing_apikey": this.SimRacingAPIKey = element.value; break;
            case "simracing_venueid": this.SimRacingVenueID = element.value; break;
            case "BookingNotificationEmail": this.BNemail = element.value; break;
            case "BookingNotification": this.BookingNotification = element.value === "true"; break;
            case "brevo_enabled": this.BrevoEnabled = element.value === "true"; break;
            case "brevo_apikey": this.BrevoAPIKey = element.value; break;
            case "mailchimp_enabled":
              this.MailChimpEnabled = element.value === "true";
              this.mailchimpEnabled = element.value === "true";
              break;
            case "mailchimp_apikey":
              this.MailChimpAPIKey = element.value;
              this.apiKey = element.value;
              break;
          }
        });
        this.busyService.idle();
      } else {
        this.messageService.add({severity: 'error', summary: 'Unable to get Venue Settings'});
        this.busyService.idle();
      }
    }, error => {
      this.messageService.add({severity: 'error', summary: 'Unable to get Venue Settings'});
      this.busyService.idle();
    });
  }

  saveSettings(): void {
    this.MailChimpEnabled = this.mailchimpEnabled;
    this.MailChimpAPIKey = this.apiKey;

    this.settingsSaving = true;
    this.updateSettingsData(false, () => {
      this.http.get(bmxurl + "MailChimpSetupMergeFields/" + this.VenueID).subscribe({
        next: () => {
          this.settingsSaving = false;
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'MailChimp Set-up Merge Fields Successful' });
          setTimeout(() => this.router.navigate(['/integrations']), 2000);
        },
        error: () => {
          this.settingsSaving = false;
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'MailChimp Set-up Merge Fields Failed' });
          setTimeout(() => this.router.navigate(['/integrations']), 2000);
        }
      });
    });
  }

  goBack(): void {
    this.router.navigate(['/integrations']);
  }

  onMailChimpEnabledChange(): void {
    this.MailChimpEnabled = this.mailchimpEnabled;
    if (!this.mailchimpEnabled) {
      this.apiKey = "";
      this.MailChimpAPIKey = "";
    }
  }
}
